// extracted by mini-css-extract-plugin
export default {"title":"Report_title__+OVR4","text":"Report_text__Spv9Z","info":"Report_info__xW2Sp","input":"Report_input__h8K+5","btns":"Report_btns__V5JJa","button":"Report_button__hFefQ"};